import { APISettings } from '../../config/ApiSettings';
import { BaseAPI } from './baseApi';

const baseUrl = new APISettings().getApiURL();

class DocumentTypeApi extends BaseAPI {
  public get: () => Promise<any> = async () => {
    return (await BaseAPI.axios.get(`${baseUrl}/DocumentType`)).data.output;
  };
}

export const documentTypeApi = new DocumentTypeApi();
